const IconWrapper = ({ className = '', viewBox = '0 0 24 24', children }) => (
  <svg
    className={className}
    viewBox={viewBox}
    width='1em'
    height='1em'
    aria-hidden='true'
    focusable='false'
  >
    {children}
  </svg>
)

const SunIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <circle cx='12' cy='12' r='4' fill='none' stroke='currentColor' strokeWidth='2' />
    <path
      d='M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </IconWrapper>
)

const MoonIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <path
      d='M21 12.8A9 9 0 1111.2 3a7 7 0 109.8 9.8z'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconWrapper>
)

const MenuIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <path
      d='M4 7h16M4 12h16M4 17h16'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </IconWrapper>
)

const CloseIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <path
      d='M6 6l12 12M18 6L6 18'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </IconWrapper>
)

const ArrowUpIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <path
      d='M12 19V5m0 0l-6 6m6-6l6 6'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconWrapper>
)

const MailIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <rect
      x='3'
      y='5'
      width='18'
      height='14'
      rx='2'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
    />
    <path
      d='M4 7l8 6 8-6'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconWrapper>
)

const LinkedInIcon = ({ className = '' }) => (
  <IconWrapper className={className} viewBox='0 0 24 24'>
    <path
      d='M7.2 8.2a1.7 1.7 0 11.1-3.4 1.7 1.7 0 01-.1 3.4zM5.7 9.8h3v9.5h-3zM11 9.8h2.9v1.3h.1a3.2 3.2 0 012.9-1.6c3.1 0 3.6 2 3.6 4.6v5.2h-3v-4.6c0-1.1 0-2.5-1.6-2.5s-1.8 1.2-1.8 2.4v4.7h-3z'
      fill='currentColor'
    />
  </IconWrapper>
)

const GitHubIcon = ({ className = '' }) => (
  <IconWrapper className={className} viewBox='0 0 24 24'>
    <path
      d='M12 .5a11.5 11.5 0 00-3.6 22.4c.6.1.8-.2.8-.6v-2.1c-3.2.7-3.9-1.4-3.9-1.4-.5-1.3-1.3-1.7-1.3-1.7-1.1-.8.1-.8.1-.8 1.2.1 1.8 1.2 1.8 1.2 1.1 1.8 2.8 1.3 3.4 1 .1-.8.4-1.3.7-1.6-2.5-.3-5.2-1.2-5.2-5.5 0-1.2.4-2.1 1.1-2.9-.1-.3-.5-1.5.1-3.1 0 0 1-.3 3.2 1.1a11.2 11.2 0 015.8 0c2.2-1.4 3.2-1.1 3.2-1.1.6 1.6.2 2.8.1 3.1.7.8 1.1 1.7 1.1 2.9 0 4.3-2.7 5.2-5.2 5.5.4.3.8 1 .8 2.1v3.1c0 .4.2.7.8.6A11.5 11.5 0 0012 .5z'
      fill='currentColor'
    />
  </IconWrapper>
)

const ExternalLinkIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <path
      d='M14 4h6v6m0-6l-9 9'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h5'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconWrapper>
)

const SearchIcon = ({ className = '' }) => (
  <IconWrapper className={className}>
    <circle cx='11' cy='11' r='6' fill='none' stroke='currentColor' strokeWidth='2' />
    <path
      d='M16 16l5 5'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </IconWrapper>
)

export {
  ArrowUpIcon,
  CloseIcon,
  ExternalLinkIcon,
  GitHubIcon,
  LinkedInIcon,
  MailIcon,
  MenuIcon,
  MoonIcon,
  SearchIcon,
  SunIcon,
}
